<template>
  <!-- 问卷调查管理-问卷列表 -->
  <basic-container>
    <avue-crud
      ref="crud"
      :option="tableOption"
      :table-loading="loading"
      :data="tableData"
      :page.sync="tablePage"
      :search.sync="searchForm"
      :before-open="beforeOpenForm"
      :before-close="beforeCloseForm"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="loadData"
      @on-load="loadData"
    >
      <template slot="menuLeft">
        <el-button
          v-if="permissionList.addBtn"
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="openDialog('add')"
        >
          新增
        </el-button>
      </template>
      <template slot-scope="{ row }" slot="menu">
        <el-button
          v-if="permissionList.editBtn && row.publishStatus == 1"
          size="small"
          type="text"
          @click="openDialog('edit', row)"
        >
          编辑
        </el-button>
        <el-button
          v-if="permissionList.delBtn && row.publishStatus != 2"
          size="small"
          type="text"
          @click="showConfirm('del', row)"
        >
          删除
        </el-button>
        <el-button
          v-if="permissionList.releaseBtn && row.publishStatus == 1"
          size="small"
          type="text"
          @click="showConfirm('release', row)"
        >
          发布
        </el-button>
        <el-button
          v-if="permissionList.offBtn && row.publishStatus == 2"
          size="small"
          type="text"
          @click="showConfirm('off', row)"
        >
          下架
        </el-button>
      </template>
    </avue-crud>
    <!-- 弹框 -->
    <el-dialog
      :title="dialogTitle"
      width="60%"
      :visible.sync="isDialogShow"
      :before-close="beforeCloseDialog"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <Form
        v-if="isDialogShow"
        :dialogType="dialogType"
        :rowData="rowData"
        :projectId="searchForm.projectId"
        @update="updateTableDataSuccess"
        @close="beforeCloseDialog"
      ></Form>
    </el-dialog>
  </basic-container>
</template>

<script>
import Form from './form';
import { mapGetters } from 'vuex';
import { getProjectListApi } from '@/api/call-system/index';
import {
  getPageListApi,
  delApi,
  switchStatusApi,
} from '@/api/call-system/questionnaire-manage/questionnaire-list';

export default {
  components: {
    Form,
  },
  data() {
    return {
      oldProjectId: '', // 旧项目id，重置搜索条件和新增时需要使用
      projectList: [], // 项目列表
      searchForm: {}, // 搜索条件
      dialogType: '', // 弹框的类型
      dialogTitle: '', // 弹框显示的标题
      isDialogShow: false, // 弹框是否显示着
      needCloseConfirm: false, // 关闭弹框时是否需要确认弹框，该值是根据场景动态调整的
      loading: false, // 是否正在加载表格数据
      tableData: [], // 表格数据
      // 数据的分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 表格显示的配置项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        dialogClickModal: false,
        searchMenuSpan: 18,
        searchLabelWidth: 100,
        labelWidth: 100,
        column: [
          {
            label: '项目名称',
            prop: 'projectId',
            dicData: [],
            props: {
              label: 'name',
              value: 'id',
            },
            type: 'select',
            hide: true,
            showColumn: false,
            display: false,
            // search: true,
            // searchClearable: false,
          },
          {
            label: '问卷名称',
            prop: 'name',
            search: true,
            maxlength: 20,
            showWordLimit: true,
          },
          {
            label: '开始日期',
            prop: 'startDate',
          },
          {
            label: '结束日期',
            prop: 'endDate',
          },
          {
            label: '问卷链接',
            prop: 'link',
          },
          {
            label: '状态',
            prop: 'publishStatus',
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=callcenter_publish_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(
          this.permission.callSystem_questionnaireManage_questionnaireList_add,
          false
        ),
        delBtn: this.vaildData(
          this.permission.callSystem_questionnaireManage_questionnaireList_del,
          false
        ),
        editBtn: this.vaildData(
          this.permission.callSystem_questionnaireManage_questionnaireList_edit,
          false
        ),
        releaseBtn: this.vaildData(
          this.permission.callSystem_questionnaireManage_questionnaireList_release,
          false
        ),
        offBtn: this.vaildData(
          this.permission.callSystem_questionnaireManage_questionnaireList_off,
          false
        ),
      };
    },
  },
  created() {
    getProjectListApi().then(({ data }) => {
      this.projectList = data || [];
      if (this.projectList.length > 0) {
        this.findObject(this.tableOption.column, 'projectId').dicData = this.projectList;
        this.searchForm.projectId = this.projectList[0].id;
        this.loadData();
      }
    });
  },
  mounted() {
    this.ajustView();
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  methods: {
    /* 调整视图区域 */
    ajustView() {
      const tableInitH = this.bodyHeight - 335; // 表格区域初始化高度
      const searchH = 56; // 搜索区域占的高度
      this.tableOption.height = tableInitH;

      this.$nextTick(() => {
        setTimeout(() => {
          let children = this.$refs.crud.$children[1].$children;
          children[children.length - 2].$el.addEventListener('click', () => {
            if (this.tableOption.height == tableInitH) {
              this.tableOption.height = tableInitH + searchH;
            } else {
              this.tableOption.height = tableInitH;
            }
            this.$refs.crud.getTableHeight();
          });
        });
      });

      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    /* 加载表格数据 */
    loadData(page) {
      if (!this.searchForm.projectId) return;
      this.oldProjectId = this.searchForm.projectId;
      page = page || this.tablePage;
      this.loading = true;
      getPageListApi(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.searchForm)
      ).then(({ data }) => {
        this.tablePage.total = data.total;
        this.tableData = data.records;
        this.loading = false;
      });
    },
    /* 重置搜索 */
    searchReset() {
      this.searchForm = {
        projectId: this.oldProjectId,
      };
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 条件搜索 */
    searchChange(params, done) {
      this.searchForm = params;
      this.tablePage.currentPage = 1;
      this.loadData();
      done();
    },
    /* 表格数据更新成功 */
    updateTableDataSuccess() {
      this.loadData();
      this.dialogType = '';
      this.isDialogShow = false;
    },
    /* 打开弹框 */
    openDialog(type, rowData = {}) {
      let titles = {
        add: '新增',
        edit: '编辑',
      };
      this.dialogTitle = titles[type];
      this.dialogType = type;
      this.rowData = rowData;
      this.needCloseConfirm = true;
      this.isDialogShow = true;
    },
    /* 关闭表单弹框的确认框 */
    beforeCloseDialog(done) {
      if (!this.needCloseConfirm) {
        if (typeof done == 'function') {
          done();
        } else {
          this.dialogType = '';
          this.isDialogShow = false;
        }
      } else {
        this.$confirm(' 是否关闭继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            if (typeof done == 'function') {
              done();
            } else {
              this.dialogType = '';
              this.isDialogShow = false;
            }
          })
          .catch(() => {});
      }
    },
    /* 操作确认弹框 */
    showConfirm(type, row) {
      let msgs = {
        del: '删除',
        release: '发布',
        off: '下架',
      };
      this.$confirm(`确定将选择数据${msgs[type]}?`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          if (type == 'del') {
            return delApi({
              id: row.id,
            });
          } else {
            return switchStatusApi({
              id: row.id,
              publishStatus: type == 'release' ? 2 : 3,
            });
          }
        })
        .then(() => {
          this.loadData();
          this.$message.success('操作成功!');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}
</style>
